var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';
import { emptyString } from '../../constants';
import { getConfig } from '../config';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { getTelemetryClient } from '../../clients';
var AuthenticationHelper = /** @class */ (function () {
    function AuthenticationHelper() {
        var _this = this;
        this.getGraphApiAccessToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var authResult, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 6]);
                        return [4 /*yield*/, AuthenticationHelper.msalInstance.acquireTokenSilent({
                                scopes: ['User.ReadBasic.All'],
                                account: AuthenticationHelper.msalInstance.getAllAccounts()[0],
                            })];
                    case 1:
                        authResult = _a.sent();
                        return [2 /*return*/, authResult];
                    case 2:
                        ex_1 = _a.sent();
                        if (!(ex_1 instanceof InteractionRequiredAuthError)) return [3 /*break*/, 4];
                        this.telemetryClient.trackTrace({
                            message: 'Interaction required Auth error occurred, login redirect happening...',
                            severityLevel: SeverityLevel.Information,
                        }, { ex: ex_1 });
                        return [4 /*yield*/, AuthenticationHelper.msalInstance.loginRedirect({
                                scopes: ['User.ReadBasic.All'],
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        this.telemetryClient.trackException({ exception: ex_1, severityLevel: SeverityLevel.Error });
                        _a.label = 5;
                    case 5: return [2 /*return*/, {}];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.getSmartParkingApiAccessToken = function () { return __awaiter(_this, void 0, void 0, function () {
            var authResult, ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 6]);
                        return [4 /*yield*/, AuthenticationHelper.msalInstance.acquireTokenSilent({
                                scopes: [AuthenticationHelper.environmentConfig.resourceUrl],
                                account: AuthenticationHelper.msalInstance.getAllAccounts()[0],
                            })];
                    case 1:
                        authResult = _a.sent();
                        return [2 /*return*/, authResult.accessToken];
                    case 2:
                        ex_2 = _a.sent();
                        if (!(ex_2 instanceof InteractionRequiredAuthError)) return [3 /*break*/, 4];
                        this.telemetryClient.trackTrace({
                            message: 'Interaction required Auth error occurred, login redirect happening...',
                            severityLevel: SeverityLevel.Information,
                        }, { ex: ex_2 });
                        return [4 /*yield*/, AuthenticationHelper.msalInstance.loginRedirect({
                                scopes: [AuthenticationHelper.environmentConfig.resourceUrl],
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        this.telemetryClient.trackException({ exception: ex_2, severityLevel: SeverityLevel.Error });
                        _a.label = 5;
                    case 5: return [2 /*return*/, emptyString];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.getMsGraphDetails = function (accessToken) { return __awaiter(_this, void 0, void 0, function () {
            var headers, bearer, options, response, ex_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new Headers();
                        bearer = "Bearer ".concat(accessToken);
                        headers.append('Authorization', bearer);
                        options = {
                            method: 'GET',
                            headers: headers,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(AuthenticationHelper.environmentConfig.graphEndpoint, options)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                    case 3:
                        ex_3 = _a.sent();
                        this.telemetryClient.trackException({ exception: ex_3, severityLevel: SeverityLevel.Error });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getAliasValidation = function (accessToken, alias) { return __awaiter(_this, void 0, void 0, function () {
            var headers, bearer, options, suffixes, _i, suffixes_1, suffix, response, ex_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new Headers();
                        bearer = "Bearer ".concat(accessToken);
                        headers.append('Authorization', bearer);
                        options = {
                            method: 'GET',
                            headers: headers,
                        };
                        suffixes = ['@microsoft.com', '@ntdev.microsoft.com'];
                        _i = 0, suffixes_1 = suffixes;
                        _a.label = 1;
                    case 1:
                        if (!(_i < suffixes_1.length)) return [3 /*break*/, 6];
                        suffix = suffixes_1[_i];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(AuthenticationHelper.environmentConfig.usersGraphEndpoint, "/").concat(alias).concat(suffix), options)];
                    case 3:
                        response = _a.sent();
                        if (response === null || response === void 0 ? void 0 : response.ok) {
                            return [2 /*return*/, true];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        ex_4 = _a.sent();
                        this.telemetryClient.trackException({
                            exception: ex_4,
                            severityLevel: SeverityLevel.Error,
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/, false];
                }
            });
        }); };
    }
    AuthenticationHelper.prototype.getMsalInstance = function (env, clientId) {
        if (AuthenticationHelper.environment === undefined || AuthenticationHelper.msalInstance === undefined) {
            this.telemetryClient = getTelemetryClient(env, clientId);
            AuthenticationHelper.environment = env;
            AuthenticationHelper.environmentConfig = getConfig(env);
            AuthenticationHelper.msalInstance = new PublicClientApplication({
                auth: {
                    clientId: clientId,
                    authority: AuthenticationHelper.environmentConfig.msalAuthorityUrl + AuthenticationHelper.environmentConfig.tenantId,
                    redirectUri: window.location.origin,
                },
                cache: {
                    cacheLocation: 'sessionStorage',
                    storeAuthStateInCookie: false,
                },
            });
        }
        return AuthenticationHelper.msalInstance;
    };
    return AuthenticationHelper;
}());
export var authHelper = new AuthenticationHelper();
